// import {ISmartBannerConfig} from "../interface/IConfig";
import SmartBanner from 'smart-app-banner';
import { ISmartBannerConfig } from '../interface/ISmartBanner';
import { checkIsPurple, checkIsCommunitySdk } from '../common/Utils';

/**
 * @alias SmartBanner
 * @category SmartBanner
 * @param _config {ISmartBannerConfig}
 * @example
 * if (window.ncui && window.ncui.smartbanner) {
 *    new window.ncui.smartbanner({
 *        title: "블레이드 & 소울 2",
 *        icon: "https://wstatic-cdn.plaync.com/resource/bns2/meta/icon_126.png",
 *        button: "열기",
 *    });
 * }
 */
 export default class Index {
    constructor(_config: ISmartBannerConfig) {
        // console.log('-------SmartBanner START-------', _config);

        this.init(_config);
    }

    init(_config: ISmartBannerConfig){
        // 퍼플인 경우 배너 출력 안함
        if(checkIsPurple() || checkIsCommunitySdk()){
            return;
        }

        const htmlEl: HTMLElement | null = document.querySelector('html');
        const lang = htmlEl?.getAttribute('lang')? htmlEl.getAttribute('lang')?.toLowerCase(): 'ko';

        new SmartBanner({
            appStoreLanguage: lang,
            title: _config.title,
            button: _config.button,
            icon: _config.icon,

            daysHidden: 365,
            daysReminder: 0,
            author: _config.author || 'NC',
            store: {
                ios: 'On the App Store',
                android: 'In Google Play',
                windows: 'In Windows store'
            },
            price: {
                ios: 'FREE',
                android: 'FREE',
                windows: 'FREE'
            },
            theme: 'ios'
        });
    }

} // end of class
